import React, { FC } from "react";
import { Handle, NodeProps, Position } from "reactflow";
import { useAppSelector } from "store/hooks";
import { WaitUntilIcon } from "../Icons";
import { ResponseBranchNodeData } from "./NodeData";
import { NodeDevModeHighlighter } from "./NodeDevModeHighlighter";

export const ResponseBranchNode: FC<NodeProps<ResponseBranchNodeData>> = ({
  isConnectable,
  selected,
  data: { branches, disabled, routingMode },
  id,
}) => {
  const realBranches = (branches || []).filter(
    (b) => !b.isOthers && !b.isTimeout
  );
  const hasOthers = (branches || []).some((b) => b.isOthers);
  // Old nodes saved before routingMode existed have no field; treat them
  // as keyword mode so the body text matches the matcher's behavior.
  const isAi = routingMode === "ai";

  return (
    <div
      className={`relative response-branch-node w-[260px] h-[80px] rounded bg-themed-card font-inter ${
        disabled ? "opacity-50 cursor-not-allowed" : ""
      } ${
        selected ? "border-2 border-[#6366F1]" : "border border-themed-border"
      }`}
    >
      <Handle
        position={Position.Top}
        type="target"
        isConnectable={isConnectable}
      >
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-[#6366F1]">
          <WaitUntilIcon />
        </div>
      </Handle>

      <div className="p-[16px]">
        <div className="flex justify-between font-semibold text-base mb-[2px]">
          <div>Response Branch</div>
        </div>
        <div className="font-normal text-[14px] leading-[22px] text-themed-textSecondary">
          {realBranches.length === 0 ? (
            <span className="font-inter font-normal text-[12px] text-[#F43F5E] leading-5">
              Add reply branches
            </span>
          ) : !hasOthers ? (
            <span className="font-inter font-normal text-[12px] text-[#f0a103] leading-5">
              Missing catch-all branch
            </span>
          ) : isAi ? (
            `AI routes on ${realBranches.length} reply prompt${
              realBranches.length === 1 ? "" : "s"
            }`
          ) : (
            `Routes on ${realBranches.length} reply rule${
              realBranches.length === 1 ? "" : "s"
            }`
          )}
        </div>
      </div>

      <Handle
        position={Position.Bottom}
        type="source"
        isConnectable={isConnectable}
        className="!min-h-[1px] !h-[1px] !bottom-[1px] !opacity-0 !border-0 pointer-events-none cursor-default"
      />
      <NodeDevModeHighlighter id={id} />
    </div>
  );
};
